<template>
  <section class="content white large-padding">
    <form class="hide-for-print" @submit.prevent="handleSubmit" spellcheck="false">
      <TheLoader :active="true" v-if="loading"/>

      <fieldset style="margin: 0;">
        <div class="grid-x grid-padding-x">
          <TheSelectInput
            v-model="form.avdelingsid"
            containerClassName="cell large-2"
            label="Avdeling"
            name="Avdelingsid"
            :items="avdelingOpts"
            :disabled="loading"
          />

          <TheSelectInput
            v-model="form.dateType"
            containerClassName="cell large-2"
            label="Dato"
            name="dateType"
            :items="dateTypeOpts"
            :disabled="loading"
          />

          <div class="cell large-6">
            <DateFromTillForm
              v-model="form.dates"
              :labelFrom="'Dato f.o.m'"
              :labelTill="'Dato t.o.m'"
              :requiredFrom="true"
              :requiredTill="true"
            />
          </div>
          <div class="cell auto">
            <label>&nbsp;</label>
            <button v-if="submittable" class="button primary">Ok</button>
            <button v-else-if="fetching" class="button primary loading">Ok <span class="loader-spinner"></span></button>
            <button v-else class="button primary disabled">Ok</button>

            <a v-if="items.length > 0" @click="handleExport()" href="javascript:;" class="button primary submit tiny" style="margin-left: 0.25rem;">Exporter</a>
            <a v-else href="javascript:;" class="button primary submit tiny" disabled style="margin-left: 0.25rem;">Exporter</a>
          </div>
        </div>
      </fieldset>
    </form>

    <div class="content-container flex-column">
      <div class="content-container flex-row content-x-scroll content-y-scroll table-results">
        <!-- <tbody class="empty-container">
          <tr>
            <td colspan="6">
              <em v-if="searched">Fant ingen data...</em>
              <em v-else>Søk med fra/til dato...</em>
            </td>
          </tr>
        </tbody> -->
        <table v-if="items.length > 0" class="large fixed sortable sticky-table-header compressed color-rows" style="height: 0">
          <thead>
            <tr>
              <th v-for="heading in headers" :key="heading.key">{{heading.name}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in visibleItems" :key="item.Objektid">
              <td v-for="heading in headers" :key="heading.key">
                <span v-if="item.hasOwnProperty(heading.key)">{{item[heading.key]}}</span>
                <span v-else>-</span>
              </td>
            </tr>
            <tr v-if="visibleItems.length < items.length">
              <td colspan="500">
                Last ned CSV for å se alle ({{items.length}}) objekter...
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<script>
import DateFromTillForm from '@/components/Inputs/DateFromTillForm'
import StatistikkService from '@/services/StatistikkService'
import InstillingerService from '@/services/InstillingerService'
import moment from 'moment'
import Papa from 'papaparse'
import fileDownload from 'js-file-download'

export default {
  name: 'StatsFullobjekt',
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    DateFromTillForm
  },
  data () {
    return {
      loading: false,
      fetching: false,
      searched: false,
      avdelingOpts: [],
      dateTypeOpts: [
        { key: 'faktura', val: 'Faktura dato' },
        { key: 'reg', val: 'Registrert dato' }
      ],
      items: [],
      headers: [],
      form: {
        avdelingsid: null,
        dateType: 'faktura',
        dates: {
          from: null,
          till: null
        }
      }
    }
  },
  computed: {
    submittable: function () {
      return !this.loading && !this.fetching && this.form.dates.from && this.form.dates.till
    },
    visibleItems: function () {
      return this.items && this.items.length > 200 ? this.items.slice(0, 200) : this.items
    }
  },
  mounted () {
    this.fetchSettings()
  },
  methods: {
    handleSubmit: function () {
      if (!this.submittable) {
        return
      }

      // Make query
      const query = {
        from: this.form.dates.from,
        till: this.form.dates.till,
        avdelingsid: this.form.avdelingsid
      }

      if (this.form.dateType) {
        query.dateType = this.form.dateType
      }

      this.headers = []
      this.items = []

      this.searched = false
      this.fetching = true

      StatistikkService.loadFullobjektJson(query)
        .then(response => {
          const items = response.data

          if (items && items.length > 0) {
            // Build headers
            this.headers = []
            Object.keys(items[0]).forEach(value => {
              this.headers.push(
                {
                  key: value, default: '', name: value
                }
              )
            })

            this.items = items
          } else {
            this.headers = []
            this.items = []
          }
        })
        .catch(error => {
          console.log('Error')
          console.log(error)

          this.$helpers.showErrorAlert('Feil', 'Noe gikk galt, prøv igjen')

          this.headers = []
          this.items = []
        })
        .then(() => {
          this.fetching = false
          this.searched = true
        })
    },
    handleExport: function () {
      if (this.items.length < 1) {
        this.$helpers.showErrorAlert('Feil', 'Ingen objekter at exportere')
        return
      }

      const data = []

      data.push(this.headers.map(h => h.name))

      this.items.forEach(item => {
        const line = []
        this.headers.forEach(heading => {
          if (item.hasOwnProperty(heading.key)) {
            line.push(item[heading.key])
          }
        })

        data.push(line)
      })

      // Finally make csv and force download...
      const csv = '\ufeff' + Papa.unparse(data, { delimiter: ';' })
      const blob = new Blob([csv], {
        type: 'application/csvcharset=utf-8'
      })

      fileDownload(blob, 'objekt-rapport-' + moment().format('DDMMYY.Hms') + '.csv')
    },
    fetchSettings: function () {
      this.loading = true

      this.avdelingOpts.unshift({key: null, val: 'Laster...'})

      InstillingerService('avdeling').dropdown()
        .then((response) => {
          this.avdelingOpts = response.data
          this.avdelingOpts.unshift({ key: null, val: 'Alle' })
        })
        .catch(() => {
          // Skip error
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste ned avdeling innstillinger')
        })
        .then(() => {
          this.loading = false
        })
    }
  }
}
</script>
<style scoped>
  table.fixed tbody.empty-container tr td:after {
    border: none;
    background-color: revert;
  }

  table.fixed tbody tr.footer td {
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/Reports/Stats/StatsFullobjekt.vue